export default __webpack_public_path__ + "static/media/i158sp.95407381.webp";